import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const Clock = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M12.605,24c-6.617,0-12-5.383-12-12c0-6.617,5.383-12,12-12c6.617,0,12,5.383,12,12C24.605,18.617,19.223,24,12.605,24z M12.605,2c-5.514,0-10,4.486-10,10c0,5.514,4.486,10,10,10c5.514,0,10-4.486,10-10C22.605,6.486,18.119,2,12.605,2z" }),
    React.createElement("polygon", { points: "19.605,13 11.605,13 11.605,5 13.605,5 13.605,11 19.605,11" })), 'Clock');
export default Clock;
